import { useState } from 'react'
import { legacyFaqItems } from '@content/home'

export function HomeFaq() {
  const [openId, setOpenId] = useState<string | null>(legacyFaqItems[0]?.id ?? null)

  return (
    <ul className="faq-list">
      {legacyFaqItems.map((item) => {
        const open = item.id === openId
        return (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={open ? '' : 'collapsed'}
              onClick={(event) => {
                event.preventDefault()
                setOpenId(open ? null : item.id)
              }}
            >
              {item.question}
              <i className="bx bx-chevron-down icon-show"></i>
              <i className="bx bx-chevron-up icon-close"></i>
            </a>
            <div
              id={item.id}
              className={open ? 'collapse show' : 'collapse'}
              dangerouslySetInnerHTML={{ __html: item.answerHtml }}
            />
          </li>
        )
      })}
    </ul>
  )
}
